import { renderModalCredits } from "scripts/components/react/ModalCredits";


const modalCredits = {
  call: () => {
    renderModalCredits()
  }
}

export default modalCredits;